<mat-form-field class="form-field" [appearance]="appearance">
    
    <mat-label>
        Vertragsstatus
    </mat-label>

    <mat-select [formControl]="valueControl">
        <mat-option *ngFor="let status of (contractStatus$|async)" [value]="status.contractstateid">
            {{status.contractstatename}}
        </mat-option>
    </mat-select>

</mat-form-field>
